import React, { useEffect, useState } from "react";
import Table from "../../Common/Table";
import TableFields from "../../../constants/DriverSupport/RiderPayouts/TableFields.json";
import { getPath } from "../../../utils";

const PAYOUT_IDENTIFIER = {
  INSTANT_TIP: "Order ID",
  RIDER_WEEKLY_PAYOUT: "Payout Date",
  INSTANT_PAYOUT: "Payout Date",
  RIDER_WEEKLY_TIP: "Payout Date",
  INSTANT_TIP_WITHDRAW: "Payout Date",
};
const RiderPayoutsList = ({ list, filters }) => {
  const getFieldValue = (item, key) => {
    return getPath(item, key, "NA");
  };
  const [updatedFields, setUpdatedFields] = useState([...TableFields]);

  useEffect(() => {
    const heading = PAYOUT_IDENTIFIER[filters["payout_type"]];
    const newFields = [...updatedFields];
    var indexToChange = newFields.findIndex((v) => v.key === "payout_for");

    newFields[indexToChange]["heading"] = heading;
    setUpdatedFields(newFields);
  }, [filters]);

  return (
    <Table list={list} getFieldValue={getFieldValue} fields={updatedFields} />
  );
};

export default RiderPayoutsList;
